import React from "react";
import {
  Search,
  Tags,
  Layers,
  Database,
  Terminal,
  Grid,
  PenTool,
  MessageSquare,
  Compass,
} from "lucide-react";

const AICapabilitiesMarquee = () => {
  const capabilities = [
    { id: 1, name: "Semantic Search", icon: Search },
    { id: 2, name: "Auto Tagging", icon: Tags },
    { id: 3, name: "Vectorisation", icon: Layers },
    { id: 4, name: "RAG", icon: Database },
    { id: 5, name: "Prompt Engineering", icon: Terminal },
    { id: 6, name: "Embeddings", icon: Grid },
    { id: 7, name: "Content Generation", icon: PenTool },
    { id: 8, name: "Chatbots", icon: MessageSquare },
    { id: 9, name: "Information Finder", icon: Compass },
  ];

  const directions = [
    "animate-marquee-left",
    "animate-marquee-right",
    "animate-marquee-left",
  ];

  return (
    <section className="bg-black py-12 overflow-hidden relative">
      <div className="text-center mb-10 px-6">
        <h2 className="text-4xl lg:text-5xl font-bold text-white mb-2">
          AI <span className="text-[#2aa996]">Capabilities</span>
        </h2>
        <p className="text-gray-400 max-w-3xl mx-auto">
          Modular AI building blocks designed to work seamlessly together
        </p>
      </div>

      <div className="space-y-6">
        {directions.map((dir, idx) => (
          <div key={idx} className="relative w-full overflow-hidden">
            <div className={`flex gap-4 ${dir} whitespace-nowrap`}>
              {[...capabilities, ...capabilities].map((cap) => {
                const Icon = cap.icon;
                return (
                  <div
                    key={cap.id}
                    className="flex items-center gap-3 bg-white rounded-full px-5 py-2 shadow-md min-w-max hover:scale-105 transition-transform"
                  >
                    <Icon className="w-5 h-5 font-light text-[#2aa996]" />
                    <span className="text-gray-800 font-semibold text-sm">
                      {cap.name}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>

      {/* Tailwind animation */}
      <style jsx>{`
        .animate-marquee-left {
          animation: marquee-left 20s linear infinite;
        }
        .animate-marquee-right {
          animation: marquee-right 20s linear infinite;
        }
        @keyframes marquee-left {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        @keyframes marquee-right {
          0% {
            transform: translateX(-50%);
          }
          100% {
            transform: translateX(0);
          }
        }
      `}</style>
    </section>
  );
};

export default AICapabilitiesMarquee;
